
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/awin-alternative",
      function () {
        return require("private-next-pages/awin-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/awin-alternative"])
      });
    }
  